/**
 * File components/Locations.js
 *
 * To display the Locations accordion
 *
 * Learn more: https://saint-augustin.ch
 */

import React, {useState} from 'react';
import {useBookingDataContext} from '../context/BookingDataProvider';

const Locations = () => {
	const {
		locations, 
		selectLocation, 
		selectEquipment, 
		isLoading, 
		error,
		setDisponibilityStatus
	} = useBookingDataContext();

	const handleLocationToggle = (index) => (e) => {
		selectLocation(index, e.target.checked);
		setDisponibilityStatus(false);
	};

	const handleEquipmentToggle = (locIndex, eqIndex) => (e) => {
		selectEquipment(locIndex, eqIndex, e.target.checked);
		setDisponibilityStatus(false);
	};

	if (isLoading) return <div>Chargement des lieux de réservation...</div>;
 	if (error) return <div className="text-red-600">{error}</div>;

	return (
		<div className="accordion">
			{locations?.length > 0 && locations.map((loc, index) => (
				
				<div className="card" key={index}>
					<div className="card-header">
						<input
							type="checkbox"
							checked={loc.isSelected}
							id={`loc-${index}`}
							onChange={handleLocationToggle(index)}
							className="form-check-input"
						/>
						<a
							href={`/location/${loc.slug}`} target="_blank"
							rel="noreferrer"
						>
							{loc.title.rendered} – {loc.building_name}
						</a>
					</div>
					{loc.isSelected && (
						<div className="card-body">
							{loc.equipments?.map((equip, equipIndex) => (
								<div key={equipIndex}>
									<input
										type="checkbox"
										className="form-check-input"
										id={`equip-${index}-${equipIndex}`}
										disabled={equip.price == 0} checked={equip.isSelected}
										onChange={handleEquipmentToggle(index, equipIndex)}
									/>
									<label htmlFor={`equip-${index}-${equipIndex}`}>{equip.name}</label>
									<span className="equipment-price">
										CHF {equip.price} {equip.price_type === 'pro_person' ? '/ par personne' : equip.price_type === 'pro_hour' ? '/ par heure' : ''}
									</span>
									<br />
								</div>
							))}
						</div>
					)}
				</div>
			))}	
		</div>
	);
}

export default Locations;